
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { postHeaders } from "@/api/api-require";
import axios from "axios";
import i18n from "@/config/i18n";
@Component
export default class PiExportAll extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private data!: objAny;

  @Prop({ default: "" }) private fileName!: string;
  @Prop({ default: "post" }) private method!: string;
  @Prop({ default: ".xls" }) private command!: string;
  @Prop({ default: "" }) private url!: string;
  @Prop({ default: i18n.t("formText.export") }) private btnName!: string;
  @Prop({ default: "primary" }) private btnType!: string;
  private progress = "";
  private loading = false;
  private globalPageIndex = 0;
  private totalpage = 0;
  private ajaxCancel: any = {};

  public getData(globalPageIndex?: number): objAny {
    const data: objAny = {};
    for (const i in this.data) {
      if (this.data[i]) {
        data[i] = this.data[i];
      }
    }
    data.globalPageIndex =
      typeof globalPageIndex == "number" ? globalPageIndex : 1; // 第一页
    data.globalPageSize = 50000;
    data.size = 50000;
    if (data.endTime) {
      const thisTime = this["$common"].thisTimes("yyyy-MM-dd HH:MM:SS");
      const thisTimeArr = thisTime.split(" ");
      const endTimeArr = data.endTime.split(" ");
      if (
        thisTimeArr[0] === endTimeArr[0] &&
        endTimeArr[1] &&
        endTimeArr[1] === "23:59:59"
      ) {
        // 如果结束时间为当前一天
        data.endTime = thisTime;
      }
    }
    return data;
  }
  async exportData(globalPageIndex?: number): Promise<void> {
    if (!this.loading) {
      const data = this.getData(globalPageIndex);
      this.loading = true;
      const headers = postHeaders({ filename: "utf-8" });
      let url = this.$config.ajaxHost + this.url;
      if (this.method === "postStr" || this.method === "get") {
        url = url + "?" + this["$common"].parseParam(data);
      }
      const CancelToken = axios.CancelToken;
      var that = this; // eslint-disable-line
      axios({
        method: this.method === "get" ? "get" : "post",
        url: url,
        data: this.method === "postStr" ? {} : data,
        responseType: "arraybuffer",
        headers: headers,
        timeout: 5 * 60 * 1000,
        cancelToken: new CancelToken(function executor(c) {
          that.ajaxCancel = c;
        })

        // onDownloadProgress: (progress: objAny) => {
        //   progress.srcElement.getResponseHeader("content-length");
        //   // console.log(progress);
        //   if (progress.total > 0) {
        //     const text = Math.round((progress.loaded / progress.total) * 100);
        //     if (this.progress == "" && text != 100) {
        //       // 有的一上来就一百就算了，不显示 了
        //       this.progress = text + "%";
        //     }
        //   }
        // },
      })
        .then(async result => {
          console.log(result.headers);
          this.loading = false;
          const totalpage = result.headers["totalpage"] || 1;
          this.globalPageIndex = data.globalPageIndex;
          this.totalpage = totalpage;
          if (data.globalPageIndex < totalpage) {
            this.exportData(data.globalPageIndex + 1);
            const progress = (data.globalPageIndex / totalpage) * 100;
            this.progress = progress.toFixed(2) + "%";
          } else {
            this.progress = "";
          }

          // this.progress = "";
          this.ab2str(result.data, (str: string) => {
            if (this.isJSON(str)) {
              const jsonData = JSON.parse(str);
              this.$Message.error(jsonData.msg);
            } else {
              this.loadBlob(result.data);
            }
          });
        })
        .catch((error: objAny) => {
          this.loading = false;
          this.progress = "";
          console.log(error);
          if (error.status && error.status != -1) {
            this.$Modal.error({
              title: i18n.t("tips") + "",
              content: i18n.t("formText.exportError") + ""
            });
          }
          // this.$Message.error('')
        });
    }
  }
  public ab2str(u: Blob, f: objAny): void {
    const b = new Blob([u]);
    const r = new FileReader();
    const loadBlob = this.loadBlob;
    r.readAsText(b, "utf-8");
    r.onload = function() {
      if (f) {
        f.call(null, r.result); // eslint-disable-line
      }
    };
    r.onerror = function() {
      loadBlob(u);
    };
  }
  public isJSON(str: string): boolean {
    if (typeof str === "string") {
      try {
        const obj = JSON.parse(str);
        if (typeof obj === "object" && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  }
  public loadBlob(data: Blob): void {
    const blob = new Blob([data], {
      type: "application/octet-stream;charset=utf-8"
    });
    const win: objAny = window;
    const doc: objAny = document;
    const downloadElement: objAny = doc.createElement("a");
    const href: objAny = win.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    const name =
      this.totalpage > 1
        ? this.fileName + "-" + this.globalPageIndex
        : this.fileName;
    downloadElement.download = name + this.command; // 下载后文件名
    doc.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    doc.body.removeChild(downloadElement); // 下载完成移除元素
    win.URL.revokeObjectURL(href); // 释放blob对象
  }

  public closeAjax(): void {
    typeof this.ajaxCancel == "function" && this.ajaxCancel();
  }

  destroyed(): void {
    this.closeAjax();
  }
}
